module.exports = __webpack_public_path__ + "static/freedom-furniture-d217ba18b62f3a521668f27f2d719b9e.svg";